import React, { useEffect, useState } from "react";
// import CountUp from "react-countup";
// import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import "./styles/hideouts.scss";
import { FaArrowRight } from "react-icons/fa";
// import { FiArrowRight } from "react-icons/fi";
import { CONFIG } from "../../../config.js";
import { ABI, DashboardFunctions } from "./functions";
import { toast, ToastContainer } from "react-toastify";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";
import AlphaherdSectionContentCard from "./component/shared/card/alphaherd.sectionContentCard";
import NewsLetterSection from "./component/shared/footer/newLetterSection";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO

const NewHideOuts = () => {
  const {
    authenticate,
    isAuthenticated,
    user,
    Moralis,
    setUserData,
    userError,
    isWeb3Enabled,
    account,
    ...xyz
  } = useMoralis();
  const [mintAmount, setMintAmount] = useState({
    mintQuantity: 0,
  });

  useEffect(() => {
    console.log("SSS");
    let tempIndicator = 0;
    if (tempIndicator) {
      setShowClaimButton(false);
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      await Moralis.enableWeb3();
      // You can await here
      // const response = await MyAPI.getData(someId);
      // var wallet = user.get("ethAddress");
      // console.log("walletAdd", wallet);
      // console.log("user", user);

      // let xxx = Moralis.User.current().get("ethAddress");
      // let xxx = await user.get("ethAddress");

      // console.log("getWalletAddress", xxx);
      // console.log("xxx", xxx);

      let getAccount = window.localStorage.getItem("accountName");
      // getAccount = "0xF0eb3cE051ff357229118cb5B3E0CAdC82f0e39B";
      // getAccount = "0x2250F1329C20090da6BAB6ee0b9D5682F3410554";
      console.log("getAccount", getAccount);
      const ABI1 = [
        {
          inputs: [{ internalType: "address", name: "", type: "address" }],
          name: "hasClaimed",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "view",
          type: "function",
        },
      ];
      const readOptions = {
        chain: CONFIG.chainID,
        contractAddress: CONFIG.smart_contract_bannernft,
        functionName: "hasClaimed",
        abi: ABI1,
        params: {
          "": getAccount,
        },
      };
      console.log("checkTrueFalseStart");
      const message = await Moralis.executeFunction(readOptions);
      console.log("message", message);

      let tempIndicator = message;
      console.log("tempIndicatpr", tempIndicator);

      if (tempIndicator) {
        console.log("tempIndicatpr", tempIndicator);
        setShowClaimButton(false);
      }
      console.log("checkTrueFalseEnd");
    }
    fetchData();
  }, []);

  const notifySuccess = (message) =>
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyInfo = (message) =>
    toast.info(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyError = (message) =>
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  async function handleSide(option) {
    const { label, value } = option;
    console.log("value=", value, "label=", label);
    console.log(label);
    await setMintAmount({
      ...mintAmount,
      mintQuantity: value,
    });
  }

  const { data, error, fetch, isFetching, isLoading } =
    useWeb3ExecuteFunction();
  async function mintNFT2(val) {
    await Moralis.enableWeb3();

    const etherValue = val * 0.005;
    let options = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_bannernft,
      functionName: "mintHideOut",
      abi: ABI.mintHideOut,
      params: {
        _mintAmount: val,
      },
      msgValue: Moralis.Units.ETH(etherValue),
    };
    // await Moralis.enableWeb3();
    console.log("mintUser=>", user);
    try {
      const mintTransaction = await Moralis.executeFunction(options);
      console.log(
        "mintTransaction=>",
        mintTransaction,
        "mintTransactionhash",
        mintTransaction.hash
      );
      notifyInfo("Please wait for confirmation");
      await mintTransaction.wait();
      notifySuccess("Please reload after sometime to get the minted NFT");
    } catch (e) {
      console.log("mintError=>", e);
      notifyError("Oops some problem occured! Please try again later!");
    }
    if (
      typeof error?.code == "undefined" &&
      typeof error?.data != "undefined"
    ) {
      notifySuccess("Please Wait For Sometime Transaction is Successful");
    } else if (typeof error?.code != "undefined") {
      notifyError("There is some error Please Try Again Later");
    }
  }
  async function claimNFT() {
    await Moralis.enableWeb3();

    // const etherValue = val * 0.005;
    let options = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_bannernft,
      functionName: "claimHideOut",
      abi: ABI.claimHideOut,
      // msgValue: Moralis.Units.ETH(etherValue),
    };
    // await Moralis.enableWeb3();
    console.log("mintUser=>", user);
    try {
      const mintTransaction = await Moralis.executeFunction(options);
      console.log(
        "mintTransaction=>",
        mintTransaction,
        "mintTransactionhash",
        mintTransaction.hash
      );
      notifyInfo("Please wait for confirmation");
      await mintTransaction.wait();
      notifySuccess("Please reload after sometime to get the minted NFT");
    } catch (e) {
      console.log("mintError=>", e);
      notifyError("Oops some problem occured! Please try again later!");
    }
    if (
      typeof error?.code == "undefined" &&
      typeof error?.data != "undefined"
    ) {
      notifySuccess("Please Wait For Sometime Transaction is Successful");
    } else if (typeof error?.code != "undefined") {
      notifyError("There is some error Please Try Again Later");
    }
  }

  const [dropdownValue, setdropdownValue] = useState(0);
  const [showClaimButton, setShowClaimButton] = useState(true);
  const handler1 = async (value) => {
    await Moralis.enableWeb3();

    // let xxx = Moralis.User.current().get("ethAddress");
    // console.log("xxx", xxx);

    const ABI1 = [
      {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "hasClaimed",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
    ];

    let getAccount = window.localStorage.getItem("accountName");
    console.log("getAccount", getAccount);

    const readOptions = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_bannernft,
      functionName: "hasClaimed",
      abi: ABI1,
      params: {
        "": "0xF0eb3cE051ff357229118cb5B3E0CAdC82f0e39B",
      },
    };

    console.log("SSS111");
    const message = await Moralis.executeFunction(readOptions);
    console.log(message);
    console.log("SSS222");
    // -> "Hello World"

    console.log("claim your free hideout", value);
  };
  const handler2 = async (value) => {
    console.log("mint hideout", value);
    setShowClaimButton(true);
  };

  return (
    <>
      <div className="greyscheme">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <div className="hero_top">
            <div className="hero_top_img"></div>
          </div>
          <section className="hideouts_section_wrapper">
            <div className="container">
              <div className="section_wrapper">
                <div className="row">
                  <div className="col-md-12">
                    <AlphaherdSectionContentCard
                      title="Claim Your Free Hideout!"
                      titleDivider={true}
                      description="ALL MOOSE SOCIETY HOLDERS ARE ELIGIBLE TO CLAIM ONE FREE HIDEOUT!"
                      description2="Mint Price: .005 ETH + Gas Mint Max: NO LIMIT"
                      buttonText1={[`Claim Your Free Hideout`]}
                      buttonText2={[
                        {
                          text: "Mint Hideout",
                          icon: <FaArrowRight />,
                        },
                      ]}
                      // buttonHandler1={() => mintNFT2(1)}
                      buttonHandler1={() => claimNFT()}
                      buttonHandler2={() => mintNFT2(dropdownValue)}
                      isClaimButton={showClaimButton}
                      isButton={true}
                      isHorizontal={true}
                      isDropdown={true}
                      onChange={handleSide}
                      dropdownhandler={(option) =>
                        setdropdownValue(option.value)
                      }
                      dropdownOptions={[
                        { value: "1", label: "1" },
                        { value: "2", label: "2" },
                        { value: "3", label: "3" },
                        { value: "4", label: "4" },
                        { value: "5", label: "5" },
                        { value: "6", label: "6" },
                        { value: "7", label: "7" },
                        { value: "8", label: "8" },
                        { value: "9", label: "9" },
                        { value: "10", label: "10" },
                        { value: "11", label: "11" },
                        { value: "12", label: "12" },
                        { value: "13", label: "13" },
                        { value: "14", label: "14" },
                        { value: "15", label: "15" },
                        { value: "16", label: "16" },
                        { value: "17", label: "17" },
                        { value: "18", label: "18" },
                        { value: "19", label: "19" },
                        { value: "20", label: "20" },
                      ]}
                      counter={[
                        {
                          number: 1250,
                          text: "Hero Hideouts",
                          counterSuffix: "",
                          counterPrefix: "",
                        },
                        {
                          number: 1250,
                          text: "Mutant Hideouts",
                          counterSuffix: "",
                          counterPrefix: "",
                        },
                        {
                          number: 50,
                          text: "Traits",
                          counterSuffix: "+",
                          counterPrefix: "",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <br />
          <br />
          <NewsLetterSection />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};

export default NewHideOuts;
